import React from "react";

export const ReportIconSvg = ({ pathNames }) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke={pathNames?.includes("/home/report") ? "#ffffff" : "#667085"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12.083 1.667H5a1.667 1.667 0 0 0-1.667 1.666v13.334A1.667 1.667 0 0 0 5 18.333h10a1.667 1.667 0 0 0 1.667-1.666V6.25z" />
          <path d="M11.667 1.667v5h5M10 15v-3.333M6.667 15v-1.667M13.333 15v-5" />
        </g>
      </svg>
    </div>
  );
};
